import React from "react";
import { CardTitle } from "reactstrap";
import { Icon, TooltipComponent } from "../../../Component";
import { BarChart } from "../../charts/sales/Charts";

const ActiveSubscription = ({ data, chart, title, tooltipText }) => {
  return (
    <React.Fragment>
      <div className="card-title-group align-start mb-2">
        <CardTitle>
          <h6 className="title">{title ?? "Active"}</h6>
        </CardTitle>
        <div className="card-tools">
          <TooltipComponent
            icon="help-fill"
            iconClass="card-hint"
            direction="left"
            id="Tooltip-2"
            text={tooltipText ?? "Active users registered in the current calendar year, by month"}
          />
        </div>
      </div>
      <div className="align-end flex-sm-wrap g-4 flex-md-nowrap">
        <div className="nk-sale-data">
          <span className="amount">{data[0]?.count}</span>
          <span className="sub-title">
            <span className={`${data[0]?.trend === "down" ? "change down text-danger" : "change up text-success"}`}>
              <Icon name={data[0]?.trend === "down" ? "arrow-long-down" : "arrow-long-up"} />
              {data[0]?.percent}
            </span>
            {data[0]?.title}
          </span>
        </div>
        <div className="nk-sales-ck">
          <BarChart data={chart} />
        </div>
      </div>
    </React.Fragment>
  );
};
export default ActiveSubscription;
